import React from "react";
import Style from "../../styles/js/Styles";
import { ColorButton } from "../../components/common/CustomButton";
import MapLink from "../../components/common/MapLink";

export default function AlertItem({ alert, updateState, updateCenter }) {
  const style = Style();

  const state = (alert) => {
    let states = ["PENDIENTE DE RECEPCIÓN", "CONFIRMADO", "POLICIA EN CAMINO"];
    return "Estado: " + states[alert.state];
  };
  const textButton = (alert) => {
    let texts = ["CONFIRMAR RECEPCIÓN", "ENVIAR POLICIA", "CERRAR"];
    return texts[alert.state];
  };

  const [disabled, setDisabled] = React.useState(false);

  const localCenter = () => {
    updateCenter(alert.location.latitude, alert.location.longitude);
  };

  const location = (alert) => {
    if (alert.location !== undefined)
      return (
        <div>
          Ubicación:&nbsp;
          <a onClick={localCenter}>Centrar</a> |&nbsp;
          <MapLink
            latitude={alert.location.latitude}
            longitude={alert.location.longitude}
          />
        </div>
      );
    return "UBICACIÓN DESCONOCIDA";
  };

  function localUpdate() {
    setDisabled(true);
    setTimeout(() => {
      setDisabled(false);
    }, 3000);

    return updateState(alert);
  }

  return (
    <div>
      <div className={style.rowList}></div>
      <div className={style.rowList}>
        <div>
          Nombre de usuario: {alert.name} {alert.lastName}{" "}
        </div>
      </div>
      <div className={style.rowList}>
        <div>Teléfono: {alert.phoneNumber} </div>
      </div>
      {alert.violent.name !== undefined &&
      alert.violent.lastName !== undefined ? (
        <div className={style.rowList}>
          Denunciado: {alert.violent.name} {alert.violent.lastName}{" "}
        </div>
      ) : null}
      {alert.violent.phoneNumber !== undefined ? (
        <div className={style.rowList}>
          Teléfono denunciado: {alert.violent.phoneNumber}
        </div>
      ) : null}

      <div className={style.rowList}>
        <div>{location(alert)} </div>
      </div>
      <div className={style.rowList}>
        <div>{state(alert)}</div>
      </div>
      <ColorButton
        style={{ marginTop: "auto" }}
        onClick={localUpdate}
        variant="contained"
        color="primary"
        disabled={disabled}
      >
        {textButton(alert)}
      </ColorButton>
    </div>
  );
}
